import { ICenterBase } from "../../../../models";

export interface ICenterItem {
    center: ICenterBase,
    selected: boolean
}